module.exports = __webpack_public_path__ + "media/images/fbcalls/banner_hero-46de161622ea8a814bea5950246ad9f7.png";